<template>

    <div>
        <v-menu
            v-model="menuModel"
            ref="dateMenu"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            max-width="450px"
            min-width="290px"
        >
            <template v-slot:activator="{ on }">
                <v-text-field
                    v-model="computedDate"
                    :placeholder="label"
                    solo
                    prepend-icon="mdi-calendar"
                    readonly
                    v-on="on"
                    :clearable="clearable"
                    :dark="isDarkColor(backgroundColor)"
                    @input="dateCleared"
                ></v-text-field>
            </template>

            <v-date-picker
                ref="picker"
                v-model="pickerDate"
                color="primary"
                :landscape="true"
                @click:date="saveDate"
                :locale="locale"
                :min="min"
                :max="max"
                :show-current="max"
                :active-picker="activePicker"
                :dark="isDarkColor(backgroundColor)"
            ></v-date-picker>

        </v-menu>

        <v-scale-transition>
            <div class="caption red--text error-text" v-show="firstError">
                {{ firstError }}
            </div>
        </v-scale-transition>
    </div>

</template>

<script>

import {timeDisplay} from '../../mixins/timeDisplayMixin';
import colorMixin from "./colorMixin";

export default {

    mixins: [timeDisplay, colorMixin],

    props: {
        value: {
            type: String | null,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: 'Date'
        },
        min: {
            type: String,
            required: false,
            default: null
        },
        max: {
            type: String,
            required: false,
            default: null
        },
        clearable: {
            type: Boolean,
            required: false,
            default: false,
        },
        locale: {
            type: String,
            required: false,
            default: 'en-US'
        },
        backgroundColor: {
            type: String,
            required: true,
        },
        startWithYear: {
            type: Boolean,
            required: false,
            default: false,
        },
        errorMessages: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    data() {
        return {
            menuModel: false,
            activePicker: null,
        }
    },

    watch: {
        menuModel(val) {
            if (this.value === null && this.startWithYear) {
                val && setTimeout(() => (this.activePicker = 'YEAR'))
            }
        },
    },

    computed: {

        pickerDate: {
            get() {
                return this.value;
            },
            set(pickerDate) {
                this.$emit('input', pickerDate);
            }
        },

        computedDate() {
            if (!this.value) {
                return null;
            }

            if (this.value) {
                return this.formatDate(this.value)
            }
        },

        firstError() {
            if (this.errorMessages.length > 0) {
                return this.errorMessages[0];
            }
            return null;
        }
    },

    methods: {

        saveDate() {
            this.$refs.dateMenu.save(this.pickerDate);
        },

        dateCleared(date) {
            if (!date) {
                this.$emit('input', null);
            }
        }
    }
}
</script>

<style scoped>

.error-text {
    position: relative;
    bottom: 15px;
    left: 35px;
}

</style>